import React from 'react';
import type { FC } from 'react';
import type { TableCellProps } from '@mui/material';
import { Link, Stack, TableCell } from '@mui/material';
import type { VersionAsset } from '../../../contexts/VersionsContext';
import { publicPath } from '../../../utils/path';

interface MacCellProps extends TableCellProps {
  assets?: VersionAsset[];
}

export const MacCell: FC<MacCellProps> = ({ assets, ...props }) => (
  <TableCell component='th' scope='row' {...props}>
    {assets && (
      <Stack direction='column' spacing={1}>
        {assets.map(({ label, path }) => (
          <Link key={path} href={publicPath(path)}>
            {label}
          </Link>
        ))}
      </Stack>
    )}
  </TableCell>
);
